export default __webpack_public_path__ + "svg/calendar/2026/1/marzo.svg?4b4e0731";